import { getAppleToken } from 'shared/services/apple';
import {
  getCurrentUserAuthProvider,
  isCurrentLoginRecent,
  reauthenticateWithPassword,
} from 'shared/services/backend-api';
import { signInWithGoogle } from 'shared/services/google';

// Google and Apple re-authentication on web is a full-page redirect, not an
// in-place prompt — the caller must have nothing unsaved when it fires.
// Members wrap lazily so importing this file never touches the service module.
export const reauthenticate = Object.freeze({
  getProvider: () => getCurrentUserAuthProvider(),
  isLoginRecent: (now: Date) => isCurrentLoginRecent(now),
  withPassword: (password: string) => reauthenticateWithPassword(password),
  withGoogleRedirect: () => signInWithGoogle(),
  withAppleRedirect: () => getAppleToken(),
});
